"use client"

import { useCallback, useEffect, useRef, useState } from "react"
import { useLocale } from "../i18n/localeContext"
import { getSharedLabels } from "../Api/content"
import "./LanguageSwitcher.css"

const LanguageSwitcher = () => {
  const { locale, setLocale } = useLocale()
  const [isOpen, setIsOpen] = useState(false)
  const [sharedLabels, setSharedLabels] = useState(null)
  const dropdownRef = useRef(null)

  const setEs = useCallback(() => setLocale("es"), [setLocale])
  const setEn = useCallback(() => setLocale("en"), [setLocale])

  useEffect(() => {
    let cancel = false
    getSharedLabels(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res
        if (!cancel) setSharedLabels(data)
      })
      .catch(() => {
        if (!cancel) setSharedLabels(null)
      })
    return () => { cancel = true }
  }, [locale])

  // close on outside click
  useEffect(() => {
    const onDocClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [])

  return (
    <div className="language-switcher lang-dropdown" ref={dropdownRef}>
      <button
        type="button"
        className="lang-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        title={sharedLabels?.language_switcher_title || 'Idioma'}
      >
        {locale?.toUpperCase() === 'EN' ? 'ENGLISH' : locale?.toUpperCase() === 'ES' ? 'ESPAÑOL' : (locale?.toUpperCase() === 'EN' ? 'ENGLISH' : 'ESPAÑOL')}
      </button>
      {isOpen && (
        <div className="lang-menu" role="listbox">
          <button
            type="button"
            className={`lang-pill ${locale === "es" ? "active" : ""}`}
            onClick={() => { setEs(); setIsOpen(false); }}
            role="option"
            aria-selected={locale === 'es'}
          >
            ESPAÑOL
          </button>
          <button
            type="button"
            className={`lang-pill ${locale === "en" ? "active" : ""}`}
            onClick={() => { setEn(); setIsOpen(false); }}
            role="option"
            aria-selected={locale === 'en'}
          >
            ENGLISH
          </button>
        </div>
      )}
    </div>
  )
}

export default LanguageSwitcher
